import React, { useEffect, useState } from "react";
import { ICreateSalesData, ICustomer } from "../../../../@types";
import { CloseIcon } from "../../../../assets/icons";
import { InfoCircle } from "../../../../assets/icons/InfoCircle";
import { Pen } from "../../../../assets/icons/PenIcon";
import { Tooltip } from "../../../../assets/icons/Tooltip";
import { InvoiceErrors } from "../../../../modules/validateInvoiceForm";
import { CustomerT } from "../../../../types";
import { CreateModal } from "../../../common/CreateModal";
import { MiniCard } from "../../../common/TooltipCards/miniCards";
import { CreateCustomerModal } from "../../customer/createCustomer";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PlusIcon from "../../../../assets/icons/PlusIcon";
import SelectCustomer from "../../../Invoice/sections/customer/SelectCustomer";

interface CustomerInfoProps {
  handleSetCustomer: (selectedCustomer: ICustomer | null) => void;
  formData: ICreateSalesData;
  customer: ICustomer | null;
  validationResults: InvoiceErrors;
  setValidationResults: React.Dispatch<React.SetStateAction<InvoiceErrors>>;
  onClearError?: () => void;
  toolTipText?: string;
}

const CustomerCreateInfo: React.FC<CustomerInfoProps> = ({
  handleSetCustomer,
  formData,
  customer,
  validationResults,
  setValidationResults,
  onClearError,
  toolTipText,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [modalInView, setModalInView] = React.useState("select_customer");
  const [showCreateCustomer, setShowCreateCustomer] = useState(false);
  const location = useLocation();
  const { t } = useTranslation("invoices");
  const toggleBankModal = () => {
    setIsOpen(!isOpen);
  };

  const handleSetCustomerWrapper = (selectedCustomer: ICustomer | null) => {
    handleSetCustomer(selectedCustomer);
    if (selectedCustomer) {
      setValidationResults((prevResults) => ({
        ...prevResults,
        customerId: "",
      }));
    }
  };

  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const customerId = searchParams.get("customerId");
    const customerName = searchParams.get("customerName");
    const customerPhone = searchParams.get("customerPhone");

    if (customerId && customerName && customerPhone) {
      handleSetCustomerWrapper({
        id: customerId,
        name: customerName,
        phone: customerPhone,
      } as ICustomer);
    }
  }, [location.search]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const customerId = searchParams.get("customerId");
    const customerFirstName = searchParams.get("customerFirstName");
    const customerLastName = searchParams.get("customerLastName");
    const customerPhone = searchParams.get("customerPhone");

    if (customerId && customerFirstName && customerLastName && customerPhone) {
      handleSetCustomerWrapper({
        id: customerId,
        firstName: customerFirstName,
        lastName: customerLastName,
        phone: customerPhone,
      } as ICustomer);
    }
  }, [location.search]);

  useEffect(() => {
    if (customer) {
      setValidationResults((prevResults) => ({
        ...prevResults,
        customerId: "",
      }));
    }
  }, [customer, setValidationResults]);

  const handleClose = () => {
    setIsOpen(false);
    setModalInView("select_customer");
    // onClose && onClose();
  };

  return (
    <div>
      {/* Mobile */}

      <div className="w-full py-2 border-t border-gray-200 lg:hidden md:hidden">
        <div className="text-[14px] flex justify-between items-center">
          <p className="py-1 font-medium leading-5 text-[#000000]">Bill to</p>
          {customer && (
            <button
              onClick={toggleBankModal}
              className="font-semibold leading-5 text-[#044E97] px-2 py-1"
            >
              Change
            </button>
          )}
        </div>
        {customer ? (
          <div className="space-y-1 font-normal text-[14px] text-[#044E97] mt-2">
            <a
              target="_blank"
              href={`/customers/${customer.id}/view`}
              className="font-semibold leading-5"
            >
              {customer.name ||
                `${customer.firstName || ""} ${customer.lastName || ""}`.trim()}
            </a>
            <p>{customer.address}</p>
            <p>{[customer.city, customer.state].filter(Boolean).join(", ")}</p>
          </div>
        ) : (
          <button
            onClick={toggleBankModal}
            className="w-full font-medium leading-6 text-gray-700 flex justify-center py-3 rounded-lg border border-gray-300 mt-2"
          >
            Add Customer
          </button>
        )}
        {validationResults.customerId && (
          <div className="mt-2 xl:text-[14px] lg:text-[12px] biglg:text-[12px] 2xl:text-[14px] md:text-[11px] text-[12px]">
            <span className="text-red-500">{validationResults.customerId}</span>
          </div>
        )}
      </div>

      {/* Desktop */}
      <div className="hidden md:block">
        <div className="flex justify-between mt-[3em]">
          <div className="flex items-center justify-start">
            <p className="text-[16px] font-semibold leading-6 text-[#000000]">
              Bill to
            </p>
          </div>
          {customer ? (
            <button
              onClick={toggleBankModal}
              className="flex items-center gap-1 p-2 rounded bg-[#E0EEFE]"
            >
              <p className="font-medium leading-6 text-[16px] text-[#044E97]">
                Change Customer
              </p>
            </button>
          ) : (
            <button
              onClick={toggleBankModal}
              className="flex items-center gap-1 p-2 rounded bg-[#E0EEFE]"
            >
              <PlusIcon />
              <p className="font-medium leading-6 text-[16px] text-[#044E97]">
                Add Customer
              </p>
            </button>
          )}
        </div>
        <div
          className="lg:p-4 p-2 border shadow-sm cursor-pointer text-[#98A2B3] rounded-md lg:text-[14px] xl:text-[16px] text-[11px]  w-[full] lg:w-[370px] mt-2 pr-[1em]"
          onClick={toggleBankModal}
        >
          {customer ? (
            <div className="">
              <div className="italic text-[16px] leading-6 text-blue-500 space-y-1">
                <a
                  target="_blank"
                  href={`/customers/${customer.id}/view`}
                  className="medium leading-6"
                >
                  {" "}
                  {customer.name ||
                    `${customer.firstName || ""} ${
                      customer.lastName || ""
                    }`.trim()}
                </a>
                <p>{customer.address}</p>
                <p>
                  {[customer.city, customer.state].filter(Boolean).join(", ")}
                </p>
              </div>
            </div>
          ) : (
            <div onClick={toggleBankModal}>
              <p>
                <em>Client Name</em>
              </p>
              <p>
                <em>Address, Town, City State</em>
              </p>
              <p>
                <em>Country</em>
              </p>
            </div>
          )}
        </div>
        {validationResults.customerId && (
          <div className="mt-2 xl:text-[14px] lg:text-[12px] biglg:text-[12px] 2xl:text-[14px] md:text-[11px] text-[9px]">
            <span className="text-red-500">{validationResults.customerId}</span>
          </div>
        )}
      </div>
      {isOpen && modalInView === "select_customer" && (
        <CreateModal>
          <SelectCustomer
            handleSetCustomer={(selectedCustomer) => {
              handleSetCustomerWrapper(selectedCustomer);
              setIsOpen(false);
            }}
            formData={formData}
            customer={customer}
            // onClose={() => setIsOpen(false)}
            setIsOpen={setIsOpen}
            setModalInView={setModalInView}
          />
        </CreateModal>
      )}

      {isOpen && modalInView === "add_customer" && (
        <CreateCustomerModal
          showSideModal={isOpen}
          setShowSideModal={setIsOpen}
          handleSetCustomer={(selectedCustomer) => {
            handleSetCustomerWrapper(selectedCustomer);
            setIsOpen(false);
          }}
          onClose={handleClose}
        />
      )}
    </div>
  );
};

export default CustomerCreateInfo;
